import { render, staticRenderFns } from "./CommunityEvents.vue?vue&type=template&id=58b5b22e&scoped=true&"
import script from "./CommunityEvents.vue?vue&type=script&lang=js&"
export * from "./CommunityEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5b22e",
  null
  
)

export default component.exports